<form [formGroup]="formGroup" class="tis">
  @if (pageTitle) {
    <div class="tis-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="tis-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "radiogroup") {
      <div class="tis-row" [class.tis-locked]="isLocked(element)">
        <div class="tis-q">
          <div class="tis-q-title">
            <span>{{ getQuestionTitle(element.title) }}</span>
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="tis-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>

        <div class="tis-group">
          @for (choice of element.choices; track choice.value) {
            <label class="tis-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span class="tis-option-text">{{ choice.text }}</span>
            </label>
          }
        </div>
      </div>
    }
    @if (isScoreElement(element)) {
      <div class="tis-score" [class.tis-total]="isTotalScoreElement(element)">
        <div class="tis-score-title">
          {{ getQuestionTitle(element.title) }}
        </div>
        <div class="tis-score-value">
          {{ getScoreDisplay(element.name) }} /
          {{ getMaxScore(element.name) }}
        </div>
      </div>
    }
  }
</form>
